import React, { useState } from "react";
import { Calender, Filter } from "../../../icons";
import { useSelector, useDispatch } from "react-redux";
import {
  setIsActive,
  setEventType,
  setSortby,
} from "../../../store/slices/eventSlice";
import { RootState } from "../../../store/store";

const Sidebar: React.FC<{ className?: string }> = ({ className }) => {
  const dispatch = useDispatch();
  const { is_active, event_type, sort_by } = useSelector(
    (state: RootState) => state.event,
  );

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleFilterClick = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  const handleUpcomingEventsClick = () => {
    dispatch(setIsActive(true));
  };

  const handlePastEventsClick = () => {
    dispatch(setIsActive(false));
  };

  const handleLivestreamsClick = () => {
    if (event_type === "ONLINE") {
      dispatch(setEventType(undefined));
    } else {
      dispatch(setEventType("ONLINE"));
    }
  };

  const handleOfflineEventsClick = () => {
    if (event_type === "OFFLINE") {
      dispatch(setEventType(undefined));
    } else {
      dispatch(setEventType("OFFLINE"));
    }
  };

  const handleSortByClick = () => {
    if (sort_by === "-1") {
      dispatch(setSortby(undefined));
    } else {
      dispatch(setSortby("-1"));
    }
  };

  return (
    <div
      className={`bg-black text-white md:py-6 md:pl-8 md:pr-2 md:h-auto max-h-[100px] ${className}`}
    >
      <div className="md:bg-primary-800 bg-black flex flex-col p-4 md:rounded-xl-10">
        <div className="flex items-center text-xl font-bold mb-2">
          <div className="mr-2">
            <Calender />
          </div>
          Events
          <div className="ml-auto cursor-pointer" onClick={handleFilterClick}>
            <Filter />
          </div>
        </div>
        <div className="flex lg:flex-col flex-row relative">
          <button
            className={`text-left md:py-3 px-2 py-1 rounded-xl-10 ${is_active && "bg-[#404040]"}`}
            onClick={handleUpcomingEventsClick}
          >
            Upcoming Events
          </button>
          <button
            className={`text-left md:py-3 px-2 py-1 rounded-xl-10 ${!is_active && "bg-[#404040]"}`}
            onClick={handlePastEventsClick}
          >
            Past Events
          </button>
          {isDropdownOpen && (
            <div
              ref={dropdownRef}
              className="absolute top-[-10%] md:right-[-30%] right-0 mt-2 bg-[#404040] text-white rounded-xl shadow-lg w-48 py-6 px-4 w-[180px] space-y-4 z-50"
            >
              <div className="flex flex-row">
                <input
                  type="checkbox"
                  onClick={handleSortByClick}
                  className="w-[22px]"
                  checked={sort_by === "-1"}
                ></input>
                <span className="ml-2">Oldest first</span>
              </div>
              <div className="flex flex-row">
                <input
                  type="checkbox"
                  className="w-[22px]"
                  onClick={handleLivestreamsClick}
                  checked={event_type === "ONLINE"}
                ></input>
                <span className="ml-2">Livestreams</span>
              </div>
              <div className="flex flex-row">
                <input
                  type="checkbox"
                  className="w-[22px]"
                  onClick={handleOfflineEventsClick}
                  checked={event_type === "OFFLINE"}
                ></input>
                <span className="ml-2">Offline events</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
